import React from 'react';
import { TextField, makeStyles } from '@material-ui/core';
import { withFormsy } from 'formsy-react';
import _ from '@lodash';
import clsx from 'clsx';

const useStyles = makeStyles({
  input: {
    '& input[type=number]': {
        '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
    }
  },
});

function NumberFieldFormsy(props) {
  const importedProps = _.pick(props, [
    'autoComplete',
    'autoFocus',
    'children',
    'className',
    'defaultValue',
    'disabled',
    'FormHelperTextProps',
    'fullWidth',
    'id',
    'InputLabelProps',
    'inputProps',
    'InputProps',
    'inputRef',
    'label',
    'multiline',
    'name',
    'onBlur',
    'onChange',
    'onClick',
    'onFocus',
    'placeholder',
    'required',
    'rows',
    'rowsMax',
    'select',
    'SelectProps',
    'type',
    'variant',
    'isDisabled',
    'onKeyDown'
  ]);
  const { setValue, value, errorMessage, min = 0, className } = props;
  const classes = useStyles()

  function changeValue( event ){
    if (event.currentTarget.value < min) setValue('');
    else setValue(event.currentTarget.value);
  }

  return (
    <TextField
      {...importedProps}
      onChange={changeValue}
      value={value}
      error={Boolean(errorMessage)}
      helperText={errorMessage}
      className={clsx(classes.input, className)}
    />
  );
}

export default React.memo(withFormsy(NumberFieldFormsy));
